import * as React from 'react';

/** Material UI Packages. */
import { Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';

/** Material UI Icons. */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const TodoTable = ({ data, config, type, tableStyle }) => {
    const renderDataGrid = (rows, columns) => (
        <DataGridPremium
            rows={rows}
            columns={columns}
            density="compact"
            rowHeight={30}
            autoHeight // normally working
            sx={{
                fontSize: 11,
                border: 'none',
                '& .demurrage-cell': { color: '#d92936' },
                '& .detention-cell': { color: '#58a000' },
                '& .MuiDataGrid-columnHeader': { maxHeight: '26px' },

                ...tableStyle,
            }}
            hideFooter
            disableColumnMenu
            initialState={{
                columns: {
                    columnVisibilityModel: { id: false },
                },
            }}
            disableSelectionOnClick
        />
    );

    const renderAccordionSection = () =>
        config.title.map((item, idx) => (
            <Accordion key={idx}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    id={`panel-${idx}-header`}
                    sx={{
                        minHeight: 0,
                        '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
                        '& .MuiAccordionSummary-expandIconWrapper': { padding: 0 },
                        '&.Mui-expanded': { minHeight: 35 },
                    }}
                >
                    <Typography sx={{ fontSize: 12, color: '#262626', fontWeight: 500 }}>{item}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0, margin: 0, height: type === 'taskboard' ? '100%' : '150px' }}>
                    {renderDataGrid(data[idx], config.cols[idx])}
                </AccordionDetails>
            </Accordion>
        ));

    return (
        <Accordion sx={{ border: 'none' }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    minHeight: 0,
                    border: 'none',
                    borderRadius: 1,
                    '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
                    '& .MuiAccordionSummary-expandIconWrapper': { padding: 0 },
                    '& .MuiAccordionSummary-content': { margin: 1 },
                    '&.Mui-expanded': { minHeight: 35 },
                }}
            >
                <Typography sx={{ fontSize: 10, color: '#262626', fontWeight: 500 }}>{config.header}</Typography>
                <Typography sx={{ fontSize: 10, fontWeight: 500, color: '#262626', ml: 0.5 }}>
                    ({data.length})
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0, margin: 0, height: '100%' }}>
                {config.hasMulitiple ? renderAccordionSection() : renderDataGrid(data, config.cols)}
            </AccordionDetails>
        </Accordion>
    );
};

export default TodoTable;
